import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import LeadershipReality from '../components/LeadershipReality';
import TheApproach from '../components/TheApproach';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <LeadershipReality />
        <TheApproach />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;